<script setup lang="ts">
import { format } from 'date-fns'
import { computed } from 'vue'

import { PatientType } from '@/types'
import { Icon } from '@/ui'
import { getName } from '@/utils'

const { patient } = defineProps<{
  patient: PatientType
}>()

const text = computed(() => {
  let t = getName(patient)

  if (patient.birthday) {
    t += `, ${format(patient.birthday, 'yyyy/MM/dd')}`
  }

  return t
})
</script>

<template>
  <Icon name="UserCircleIcon" class="mr-2 size-4 stroke-slate-400" />
  <span class="mr-4">{{ text }}</span>
</template>
